/* Ad pixel loaders + weekly countdown helpers for the Weekly Special landing page. */

export function loadMetaPixel(id) {
  if (window.fbq) {
    // Global pixel already loaded — just add the special's own pixel id (no extra PageView; the router fires it).
    if (id) window.fbq("init", id);
    return;
  }
  if (!id) return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", id);
  window.fbq("track", "PageView");
}

export function loadTikTokPixel(id) {
  if (!id || window.ttq) { if (window.ttq) window.ttq.page(); return; }
  /* eslint-disable */
  !(function (w, d, t) {
    w.TiktokAnalyticsObject = t; var ttq = (w[t] = w[t] || []);
    ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"];
    ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t) { var e = ttq._i[t] || []; for (var n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]); return e; };
    ttq.load = function (e, n) {
      var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
      ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = i; ttq._t = ttq._t || {}; ttq._t[e] = +new Date();
      ttq._o = ttq._o || {}; ttq._o[e] = n || {};
      var o = document.createElement("script"); o.type = "text/javascript"; o.async = !0; o.src = i + "?sdkid=" + e + "&lib=" + t;
      var a = document.getElementsByTagName("script")[0]; a.parentNode.insertBefore(o, a);
    };
    ttq.load(id); ttq.page();
  })(window, document, "ttq");
  /* eslint-enable */
}

export function trackLead() {
  try { if (window.fbq) window.fbq("track", "Lead"); } catch { /* noop */ }
  try { if (window.ttq) window.ttq.track("SubmitForm"); } catch { /* noop */ }
}

/* Fire a conversion event anywhere in the app — loads the configured pixels first. */
export async function trackConversion(eventName, value = null) {
  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/weekly-special`);
    const d = await res.json();
    if (d.meta_pixel_id) loadMetaPixel(d.meta_pixel_id);
    if (d.tiktok_pixel_id) loadTikTokPixel(d.tiktok_pixel_id);
    setTimeout(() => {
      const payload = value != null ? { value: Number(value) || 0, currency: "USD" } : {};
      try { if (window.fbq) window.fbq("track", eventName, payload); } catch { /* noop */ }
      try { if (window.ttq && window.ttq.track) window.ttq.track(eventName === "Purchase" ? "CompletePayment" : eventName, payload); } catch { /* noop */ }
    }, 800);
  } catch { /* noop */ }
}

/* Countdown to Sunday 11:59:59 PM Central — resets automatically every week. */
export function specialDeadlineMs() {
  const nowCT = new Date(new Date().toLocaleString("en-US", { timeZone: "America/Chicago" }));
  const target = new Date(nowCT);
  target.setDate(nowCT.getDate() + ((7 - nowCT.getDay()) % 7));
  target.setHours(23, 59, 59, 999);
  return target.getTime() - nowCT.getTime();
}

export function fmtCountdown(ms) {
  if (ms <= 0) return "0h 0m 0s";
  const d = Math.floor(ms / 86400000);
  const h = Math.floor((ms % 86400000) / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  return (d > 0 ? `${d}d ` : "") + `${h}h ${m}m ${s}s`;
}
